/**
 * Horizontal Rule
 * Reusable styled HR component
 */
import { Divider } from '@mui/material';
import React from 'react';

export default function HorizontalRule() {
  return <Divider sx={{ my: '10px' }} />;
}
